import React from "react";
import { useLocation, Link } from "react-router-dom";

// Mapping URL parts to display names
const pathNameMap = {
  "": "Home",
  intro: "Intro",
  about: "About",
  price: "Price",
  contact: "Contact",
  "help-center": "Help Center",
  register: "Register",
  login: "Login",
  dashboard: "Dashboard",
  appointments: "Appointments",
  payments: "Payments",
  invoices: "Invoices",
  create: "Create",
  edit: "Edit",
  preview: "Preview",
  staffs: "Staff",
  staff: "Staff",
  doctors: "Doctors",
  receptions: "Receptions",
  customers: "Customers",
  customer: "Customer",
  listofbooking: "Bookings",
  booking: "Booking",
  book: "Walk-In Booking",
  campaigns: "Campaigns",
  medicine: "Medicine",
  nailservices: "Nail Services",
  beautyservices: "Beauty Services",
  settings: "Settings",
  visiting: "Visiting",
  reschedule: "Reschedule",
  "new-medical-recode": "New Record",
};

const Breadcrumb = () => {
  const location = useLocation();
  const pathParts = location.pathname.split("/").filter((part) => part);

  return (
    <div className="text-sm text-text mb-6 flex items-center space-x-1 ">
      <Link to="/" className="font-medium hover:underline">
        Lokalai
      </Link>
      {pathParts.map((part, index) => {
        const routeTo = "/" + pathParts.slice(0, index + 1).join("/");
        const isLast = index === pathParts.length - 1;

        const displayName = pathNameMap[part] || decodeURIComponent(part);

        return (
          <React.Fragment key={index}>
            <span className="text-[#999]">{">"}</span>
            {isLast ? (
              <span className="text-redlight font-medium">{displayName}</span>
            ) : (
              <Link to={routeTo} className="font-medium hover:underline">
                {displayName}
              </Link>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default Breadcrumb;
